// Domande suggerite all'apertura dell'assistente, scelte in base alla pagina in cui si trova l'utente.
// Le regole sono in ordine: vince la prima che corrisponde al percorso (con la query).

interface SuggestionRule { test: RegExp; area: string; questions: string[] }

const RULES: SuggestionRule[] = [
  { test: /integration=meta-ads|\/marketing/, area: 'Meta Ads', questions: [
    'Come collego una nuova pagina Facebook?', 'Perché un modulo non riceve lead?', 'Come scelgo a chi vanno i lead di un modulo?', 'Cosa fa "Aggiorna da Meta"?',
  ] },
  { test: /\/settings.*notif/, area: 'Notifiche', questions: [
    'Come spengo le notifiche per un ruolo?', 'Che differenza c\'è tra le mie notifiche e quelle del team?', 'Come ricevo le notifiche push?',
  ] },
  { test: /\/settings/, area: 'Impostazioni', questions: [
    'Come aggiungo un utente?', 'Come creo un ruolo con permessi limitati?', 'Come collego Google Calendar?', 'Come imposto la pipeline dei lead?',
  ] },
  { test: /\/leads|\/clients/, area: 'Lead', questions: [
    'Come assegno un lead a un collega?', 'Come sposto un lead di fase?', 'Come importo i lead da un file?',
  ] },
  { test: /\/deals|\/preventiv/, area: 'Offerte', questions: [
    'Come creo un preventivo?', 'Come mando un\'offerta da firmare?', 'Come aggiungo un servizio all\'offerta?',
  ] },
  { test: /\/workflow|\/automation/, area: 'Automazioni', questions: [
    'Come creo un\'automazione?', 'Perché un\'automazione non è partita?', 'Come mando un WhatsApp automatico?',
  ] },
  { test: /\/whatsapp/, area: 'WhatsApp', questions: [
    'Come collego un numero WhatsApp?', 'Come uso un modello di messaggio?', 'Chi vede le mie chat?',
  ] },
];

const GENERAL = ['Come creo un\'automazione?', 'Come funzionano le pipeline?', 'Come creo un preventivo?', 'Come configuro le email?'];

export function suggestionsFor(path: string): { area: string | null; questions: string[] } {
  const rule = RULES.find((r) => r.test.test(path));
  return rule ? { area: rule.area, questions: rule.questions } : { area: null, questions: GENERAL };
}

/** Saluto con il nome di battesimo, se c'e'. */
export function greeting(fullName?: string | null): string {
  const first = (fullName || '').trim().split(/\s+/)[0];
  return first ? `Ciao ${first}, come posso aiutarti?` : 'Come posso aiutarti?';
}
